import Axios from "axios";
const bp = "/bp";
const api = `${bp}/api`;

const get_function = (url, success, params = {}, signal = null) => {
  const token = localStorage.getItem("Token");
  Axios.get(url, {
    params,
    signal,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
    .then((res) => {
      success(res);
    })
    .catch((error) => {
      console.error("There was an error!", error);
    });
};

const post_function = async (url, success, data, isJson = true) => {
  const token = localStorage.getItem("Token");

  const headers = {
    Authorization: `Bearer ${token}`,
  };

  if (isJson) {
    headers["Content-Type"] = "application/json";
    headers["Accept"] = "application/json";
  }

  try {
    const response = await Axios.post(url, data, { headers });
    success(response);
  } catch (error) {
    success(error.response || error);
  }
};

const update_function = async (url, success, data, isJson = true) => {
  const token = localStorage.getItem("Token");
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  if (isJson) {
    headers["Content-Type"] = "application/json";
    headers["Accept"] = "application/json";
  }

  try {
    const response = await Axios.put(url, data, { headers });
    success(response);
  } catch (error) {
    success(error.response || error);
  }
};

// ===============================================GET===============================================

export const get_material_inventory = (success, params = {}, signal = null) =>
  get_function(`${bp}/bp_get_material_inventory`, success, params, signal);

export const get_parameters = (success, params = {}, signal = null) =>
  get_function(`${bp}/bp_get_parameters`, success, params, signal);

export const get_sensor_list = (success, params = {}, signal = null) =>
  get_function(`${bp}/get_sensor_list`, success, params, signal);

export const get_actionlist_data = (success, params = {}, signal = null) =>
  get_function(`${bp}/get_actionlist_data`, success, params, signal);

// export const get_device_details = (success, params = {}, signal = null) =>
//   get_function(`${bp}/get_device_details`, success, params, signal);

export const get_all_testing_type = (success, params = {}, signal = null) =>
  get_function(`${bp}/bp_get_all_testing_type`, success, params, signal);

export const get_departments = (success, params = {}, signal = null) =>
  get_function(`${bp}/departdata`, success, params, signal);

export const get_clearence_type = (success, params = {}, signal = null) =>
  get_function(`${bp}/get_clearence_type`, success, params, signal);

export const get_cleaning_type_for_line = (
  success,
  params = {},
  signal = null
) => get_function(`${bp}/get_cleaning_type_for_line`, success, params, signal);

export const get_calculation_field = (success, params = {}, signal = null) =>
  get_function(`${bp}/get_calculation_field`, success, params, signal);

export const get_units = (success, params = {}, signal = null) =>
  get_function(`${bp}/bp_get_unit`, success, params, signal);

export const get_machine_by_machine_type = (
  success,
  params = {},
  signal = null
) => get_function(`${bp}/bp_get_machine_by_machine_type`, success, params, signal);

export const get_machine_types = (success, params = {}, signal = null) =>
  get_function(`${bp}/bp_machine_cat_data`, success, params, signal);

export const get_common_sub_categories_by_machine_group = (success, params = {}, signal = null) =>
  get_function(`${bp}/get_common_sub_categories_by_machine_group`, success, params, signal);

export const get_common_sub_categories_by_location = (success, params = {}, signal = null) =>
  get_function(`${bp}/get_common_sub_categories_by_location`, success, params, signal);

export const get_standard_blocks = (success, params = {}, signal = null) =>
  get_function(`${bp}/get_standard_blocks`, success, params, signal);

export const get_process_operation_by_recipe = (
  success,
  params = {},
  signal = null
) => get_function(`${bp}/get_process_operation_by_recipe`, success, params, signal);

// Load a SINGLE process with all its operations (Process Library: a library
// process is a recipe-less Process_Config with one process).
export const get_process_with_operations = (
  success,
  params = {},
  signal = null
) => get_function(`${bp}/get_process_with_operations`, success, params, signal);

export const get_operation_type = (success, params = {}, signal = null) =>
  get_function(`${bp}/bp_get_operation_type`, success, params, signal);

export const get_operation_operation_type = (
  success,
  params = {},
  signal = null
) => get_function(`${bp}/get_operation_operation_type`, success, params, signal);

export const get_role = (success, params = {}, signal = null) =>
  get_function(`${bp}/bp_get_role`, success, params, signal);

export const get_approval_role_flow = (success, params = {}, signal = null) =>
  get_function(`${bp}/get_approval_role_flow`, success, params, signal);

export const get_werehouse_area = (success, params = {}, signal = null) =>
  get_function(`${bp}/get_werehouse_area`, success, params, signal);

export const get_process_operation_details = (
  success,
  params = {},
  signal = null
) =>
  get_function(
    `${bp}/get_process_operation_details_v1`,
    success,
    params,
    signal
  );

export const get_sub_operation_by_operation_type = (successRes, params) => {
  get_function(`${bp}/get_sub_operation_by_operation_type`, successRes, params);
};

export const get_operation_data_v1 = (successRes, params) => {
  get_function(`${bp}/get_operation_data_v1`, successRes, params);
};

export const get_process_data_for_process_id = (successRes, params) => {
  get_function(`${bp}/get_process_data_for_process_id`, successRes, params);
};

export const get_process_data_v1 = (success, params = {}, signal = null) =>
  get_function(`${bp}/get_process_data_v1`, success, params, signal);

export const get_batch_audit_log_details = (successRes, params) => {
  get_function(`${bp}/get_batch_audit_log_details`, successRes, params);
};

export const get_register_machine = (success, params = {}, signal = null) =>
  get_function(`${bp}/get_register_machine`, success, params, signal);

export const get_register_by_machine = (success, params = {}, signal = null) =>
  get_function(`${bp}/get_register_by_machine`, success, params, signal);

export const get_total_ingredients_quantity = (success, params = {}, signal = null) =>
  get_function(`${bp}/get_total_ingredients_quantity`, success, params, signal);

export const get_recipe_ingredient_remaining = (success, params = {}, signal = null) =>
  get_function(`${bp}/get_recipe_ingredient_remaining`, success, params, signal);

// ===============================================POST===============================================
export const add_process_data_v1 = (success, data) =>
  post_function(`${bp}/add_process_data_v1`, success, data, true);

export const add_operation_data_v1 = (success, data) =>
  post_function(`${bp}/add_operation_data_v1`, success, data, true);

export const edit_operation_data_v1 = (success, data) =>
  post_function(`${bp}/edit_operation_data_v1`, success, data, true);

export const delete_operation_details = (success, data) =>
  post_function(`${bp}/delete_operation_details`, success, data, true);

export const delete_process_details = (success, data) =>
  post_function(`${bp}/delete_process_details`, success, data, true);

export const edit_process_data_v1 = (success, data) =>
  post_function(`${bp}/edit_process_data_v1`, success, data, true);

// ===============================================RULES===============================================
export const get_rules_list = (success, params = {}, signal = null) =>
  get_function(`${bp}/get_rules_list`, success, params, signal);

export const create_rule = (success, data) =>
  post_function(`${bp}/create_rule`, success, data, true);

export const update_rule = (success, data) =>
  update_function(`${bp}/update_rule`, success, data, true);

// ===============================================UPDATE===============================================

export const update_product_sop = (success, data) =>
  update_function(`${bp}/update_product_sop`, success, data, true);

export const get_valve_by_machine = (success, params = {}, signal = null) =>
  get_function(`${bp}/get_valve_by_machine`, success, params, signal);

export const get_all_processes = (success, params = {}, signal = null) =>
  get_function(`${bp}/get_all_processes`, success, params, signal);

export const get_operations_by_process = (success, params = {}, signal = null) =>
  get_function(`${bp}/get_operations_by_process`, success, params, signal);
